import { useCallback } from 'react';

import { useMembershipsQuery } from '@/core/hooks/use-memberships-query';

/**
 * Hook to fetch and manage current user's workspace memberships.
 * Backed by React Query (see useMembershipsQuery).
 */
export function useMyMemberships() {
  const query = useMembershipsQuery();

  const refetch = useCallback(async () => {
    const result = await query.refetch();
    return result.data ?? [];
  }, [query]);

  return {
    memberships: query.data ?? [],
    isLoading: query.isPending || (query.isFetching && !query.isFetched),
    isPending: query.isPending,
    isFetching: query.isFetching,
    isFetched: query.isFetched,
    isError: query.isError,
    error: query.error instanceof Error ? query.error : null,
    refetch,
  };
}
